const round6Decimals = (num) => {
  const factor = 10 ** 6;
  const scaled = Number((num * factor).toPrecision(15));
  return Math.round(scaled) / factor;
};

export default round6Decimals